import { http } from '../utils/http';
import Pagination from '../interfaces/common/pagination';
import Paging from '../interfaces/common/paging';
import SortFormatterUtils from '../utils/sortFormatterUtils';
import CorrectedStatus from '../interfaces/output/correctedStatus';

export default class CorrectedStatusApi {
    static fetchCorrectedStatusById = async(correctedStatusById: string): Promise<CorrectedStatus> => {
        const { data } = await http.get<CorrectedStatus>(`correctedStatus/${correctedStatusById}`);

        return data;
    };

    static fetchCorrectedStatuses = async(paging: Paging): Promise<Pagination<CorrectedStatus>> => {
        const url = SortFormatterUtils.addSortingToUrl(paging, null, '/correctedStatus');

        const { data } = await http.get<Pagination<CorrectedStatus>>(url);

        return data;
    };
}
